import { render, staticRenderFns } from "./KPIResult.vue?vue&type=template&id=37c30b78&scoped=true&"
import script from "./KPIResult.vue?vue&type=script&lang=js&"
export * from "./KPIResult.vue?vue&type=script&lang=js&"
import style0 from "./KPIResult.vue?vue&type=style&index=0&id=37c30b78&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c30b78",
  null
  
)

export default component.exports